<template>
  <div class="player">
    <video-player
      class="video vjs-custom-skin vjs-big-play-centered"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @ready="playerReadied"
      @statechanged="playerStateChanged($event)"
    >
    </video-player>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  name: "Video",
  components: {
    videoPlayer,
  },
  props: {
    url: String,
    classId: Number,
    productId: Number,
  },
  data() {
    return {
      playerOptions: {},
      idCourse: this.$route.query.course,
      timeReprod: 0,
    };
  },
  mounted() {
    window.addEventListener('unload', this.someMethod);
    this.playerOptions = {
      responsive: true,
      fluid: true,
      // width: "100%",
      // height: 100,
      preload: "auto",
      autoplay: false,
      muted: false,
      language: "es",
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      //techOrder: ["youtube"],
      sources: [
        {
          type: "Video/mp4",
          //baseHost: "https://crm-storage-user.s3.eu-west-1.amazonaws.com/video.mp4",
          // MP4
          src: this.url,
        },
      ],
      poster: "",
      controlBar: {
        durationDisplay: true,
        timeDivider: true,
      },
    };
    setTimeout(() => {
      this.player.muted(false);
    }, 1000);
    // this.getTime();
  },
  // watch:{
  //   url: function(){
  //     console.log("cambio")
  //     // this.getTime()
  //   }
  // },  
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    ...mapGetters("course", ["urlVideo"]),

    ...mapState("course", ["lesson"]),
  },
  methods: {
    ...mapMutations("course", ["CLEAR_VIDEO"]),
    ...mapActions('course', ['updateTime', 'getTimeReproduction']),
    // Eventos del reproductor que podemos usar
    onPlayerPlay() {},
    // Caundo el usaruario ponga pause se actualizara el tiempo en que se esta quedando
    onPlayerPause(player) {
      this.actualizarTiempo(player.currentTime());
    },
    onPlayerEnded() {},
    onPlayerLoadeddata() {},
    onPlayerWaiting() {},
    onPlayerPlaying() {},
    onPlayerTimeupdate() {},
    onPlayerCanplay() {},
    onPlayerCanplaythrough() {},
    playerStateChanged() {},

    async playerReadied(player) {
      console.log("%c--- TRACE FRONTEND: Obteniendo tiempo ---", "color: #00ff00; font-weight: bold;");
      
      try {
        const response = await this.$axios.get(`/purchased/get-time?courseId=${this.productId}&classId=${this.classId}`);
        console.log("Respuesta cruda del servidor (getTime):", response.data);


        const data = response.data;
        if (data && typeof data === 'object' && data.time !== undefined) {
          this.timeReprod = data.time;
        } else {
          this.timeReprod = Number(data) || 0;
        }

        console.log("Tiempo final procesado:", this.timeReprod);
        
        if (this.timeReprod > 0) {
          player.currentTime(this.timeReprod);
        }
      } catch (err) {
        console.error("Error en trace getTime:", err);
        this.timeReprod = 0;
      }
    },

    async actualizarTiempo(time) {
      if (time && time > 0) {
        console.log("%c--- TRACE FRONTEND: Guardando progreso ---", "color: #ffaa00;", time);
        try {
          const r = await this.$axios.patch(`purchased/save-time?course_id=${this.productId}&display_time=${time}&class_id=${this.classId}`);
          console.log("Respuesta servidor save-time:", r.data);
        } catch (e) {
          console.error("Error al guardar tiempo:", e);
        }
      }
    },

    someMethod() {
      if (this.player) {
        this.actualizarTiempo(this.player.currentTime());
      }
    }
  },
  async beforeDestroy() {
    window.removeEventListener('unload', this.someMethod);
    if (this.player) {
       const currentTime = this.player.currentTime();
       await this.actualizarTiempo(currentTime);
    }
  },

  destroyed() {
    this.CLEAR_VIDEO();
  },
};
</script>

<style scoped>
@import "./style.css";
</style>
